import { API } from "@/constants/common";
import { apiClient } from "../client/apiClient";

export class AuthService {
  static instance: AuthService;

  constructor() {
    if (AuthService.instance) {
      return AuthService.instance;
    }
    AuthService.instance = this;
  }

  async verify(token: string): Promise<any> {
    const data = await apiClient.post(API.AUTH.VERIFY, {
      token: token,
    });
    return data;
  }
}
